import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PageHeaderComponent} from './page-header/page-header.component';
import {IonicModule} from '@ionic/angular';
import {TranslateModule} from '@ngx-translate/core';
import {MeasurementButtonComponent} from './measurement-button/measurement-button.component';
import {PageHeadlineComponent} from './page-headline/page-headline.component';
import {PageContentComponent} from './page-content/page-content.component';
import {RouterModule} from '@angular/router';
import {MeasurementLogoComponent} from './measurement-logo/measurement-logo.component';
import {MeasurementOverviewComponent} from './measurement-overview/measurement-overview.component';
import {PageButtonFooterComponent} from './page-button-footer/page-button-footer.component';
import {SafePipeModule} from 'safe-pipe';
import {BreathingAnimationComponent} from './breathing-animation/breathing-animation.component';


@NgModule({
    declarations: [
        PageHeaderComponent,
        PageHeadlineComponent,
        MeasurementButtonComponent,
        MeasurementLogoComponent,
        PageContentComponent,
        MeasurementOverviewComponent,
        PageButtonFooterComponent,
        BreathingAnimationComponent
    ],
    exports: [
        PageHeaderComponent,
        PageHeadlineComponent,
        MeasurementButtonComponent,
        MeasurementLogoComponent,
        PageContentComponent,
        MeasurementOverviewComponent,
        PageButtonFooterComponent,
        BreathingAnimationComponent
    ],
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule,
        RouterModule,
        SafePipeModule
    ]
})
export class PartialsModule {
}
